import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import ValidatableField from './ValidatableField';

import { getRequiredValidators } from '../../utility/validators';

import './TextField.css';

class TextComponent extends ValidatableField {
  constructor(props) {
    super(props);
    this.state.value = props.value;
    this.entryVal = null;
  }

  static get propTypes() {
    return {
      label: PropTypes.string.isRequired,
      value: PropTypes.any,
      editing: PropTypes.bool,
      name: PropTypes.string.isRequired,
      className: PropTypes.string,
      onChange: PropTypes.func,
      inputType: PropTypes.string,
      required: PropTypes.bool,
      multiLine: PropTypes.bool,
      onLoseFocus: PropTypes.func
    };
  }

  static get defaultProps() {
    return {
      onChange: () => {},
      onLoseFocus: () => {},
      validationMessage: 'Invalid Text Field'
    };
  }

  componentWillReceiveProps(props) {
    if (this.state.value !== props.value) {
      this.setState({ value: props.value }, () => this.validate());
    }
  }

  onChange(value) {
    this.setState({ value });
  }

  validate() {
    const { inputType, required } = this.props;
    const { value } = this.state;
    const validatorFns = getRequiredValidators(inputType);
    let failedValidations = 0;

    if (!required && !value) {
      return true;
    }

    validatorFns.forEach((valFn) => {
      if (!valFn(value)) {
        failedValidations += 1;
      }
    });
    if (required && !value) {
      failedValidations += 1;
    }

    if (failedValidations > 0) {
      this.setValid(false);
      return false;
    }
    this.setValid(true);
    return true;
  }

  showLabel() {
    const { editing } = this.props;
    const { value, hasFocus } = this.state;
    return !editing || !!value || hasFocus;
  }

  onFocus() {
    this.entryVal = this.state.value;
    this.setState({
      hasFocus: true
    });
  }

  onBlur(value) {
    const { onChange, onLoseFocus } = this.props;
    this.setState({
      hasFocus: false
    });
    if (this.validate()) {
      onChange(value);
      if (onLoseFocus) {
        onLoseFocus(this.entryVal, value);
      }
    }
  }

  onPressEnter(event) {
    const { name } = this.props;
    if (event.keyCode === 13) {
      event.preventDefault();
      // Non-hidden inputs
      const inputs = document.querySelectorAll('input:not([type="hidden"]):not([type="button"])');
      const currentIndex = [].indexOf.call(inputs, document.querySelector(`input[name=${name}]`));
      // Next non-hidden input (if exists)
      const nextInput = inputs[currentIndex + 1];
      if (nextInput) {
        nextInput.focus();
      }
    }
  }

  renderControl() {
    const { editing, name, className, inputType, label, required, multiLine } = this.props;
    const type = inputType || 'text';
    const placeholder = `${label} ${required ? '' : '(optional)'}`;
    const { value } = this.state;
    const useClass = classnames(className, 'TextField', `text-${name}`, { 'is-disabled': !editing, 'TextField-multiline': multiLine });

    if (!editing) {
      return (
        <span className={useClass}>{value || ''}&nbsp;</span>
      );
    }

    const inputProps = {
      placeholder: !this.showLabel() ? placeholder : '',
      name,
      className: useClass,
      value: value || '',
      onChange: event => this.onChange(event.target.value),
      onFocus: () => this.onFocus(),
      onBlur: () => this.onBlur(this.state.value)
    };

    if (multiLine) {
      return (
        <textarea {...inputProps} />
      );
    }
    return (
      <input type={type} {...inputProps} onKeyDown={event => this.onPressEnter(event)} />
    );
  }
}

export default TextComponent;



// WEBPACK FOOTER //
// ./src/recordDetail/fields/TextField.js